module.exports = __webpack_public_path__ + "img/certificate_new.d9dc7b85.svg";